import { RouteObject } from 'react-router-dom';
import { lazy, Suspense } from 'react';

// Lazy load components with loading fallback
const HomePage = lazy(() => import('../pages/home/page'));
const BoutiquePage = lazy(() => import('../pages/boutique/page'));
const ProductPage = lazy(() => import('../pages/product/page'));
const CartPage = lazy(() => import('../pages/cart/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const VybePage = lazy(() => import('../pages/vybe/page'));
const QuadluxPage = lazy(() => import('../pages/quadlux/page'));
const FormationsPage = lazy(() => import('../pages/formations/page'));
const CollaborationsPage = lazy(() => import('../pages/collaborations/page'));
const PresetsPage = lazy(() => import('../pages/presets/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const SuccessPage = lazy(() => import('../pages/success/page'));
const CancelPage = lazy(() => import('../pages/cancel/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const EventsPage = lazy(() => import('../pages/events/page'));

// Loading component optimized
const LoadingSpinner = () => (
  <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
    <div className="text-center">
      <div className="w-16 h-16 border-4 border-[#FF8A00] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
      <p className="text-[#FF8A00] font-semibold animate-pulse">Chargement...</p>
    </div>
  </div>
);

// Wrapper component with Suspense
const SuspenseWrapper = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={<LoadingSpinner />}>
    {children}
  </Suspense>
);

const routes: RouteObject[] = [
  {
    path: '/',
    element: <SuspenseWrapper><HomePage /></SuspenseWrapper>,
  },
  {
    path: '/boutique',
    element: <SuspenseWrapper><BoutiquePage /></SuspenseWrapper>,
  },
  {
    path: '/product/:id',
    element: <SuspenseWrapper><ProductPage /></SuspenseWrapper>,
  },
  {
    path: '/cart',
    element: <SuspenseWrapper><CartPage /></SuspenseWrapper>,
  },
  {
    path: '/contact',
    element: <SuspenseWrapper><ContactPage /></SuspenseWrapper>,
  },
  {
    path: '/about',
    element: <SuspenseWrapper><AboutPage /></SuspenseWrapper>,
  },
  {
    path: '/vybe',
    element: <SuspenseWrapper><VybePage /></SuspenseWrapper>,
  },
  {
    path: '/quadlux',
    element: <SuspenseWrapper><QuadluxPage /></SuspenseWrapper>,
  },
  {
    path: '/formations',
    element: <SuspenseWrapper><FormationsPage /></SuspenseWrapper>,
  },
  {
    path: '/collaborations',
    element: <SuspenseWrapper><CollaborationsPage /></SuspenseWrapper>,
  },
  {
    path: '/presets',
    element: <SuspenseWrapper><PresetsPage /></SuspenseWrapper>,
  },
  {
    path: '/success',
    element: <SuspenseWrapper><SuccessPage /></SuspenseWrapper>,
  },
  {
    path: '/cancel',
    element: <SuspenseWrapper><CancelPage /></SuspenseWrapper>,
  },
  {
    path: '/events',
    element: <SuspenseWrapper><EventsPage /></SuspenseWrapper>,
  },
  {
    path: '*',
    element: <SuspenseWrapper><NotFoundPage /></SuspenseWrapper>,
  },
];

export default routes;
